import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import _ from 'lodash';
import {
  useDispatch,
  useSelector,
} from '../../components/common/react-redux-hooks';
import CommonDropdown from '../../components/common/CommonDropdown';
import {
  getContractList,
  getLocationsList,
  getDefaultSummaryLocAndCon,
} from '../../util/ContractAdminUtils';
import {
  setEditEntitlement,
  setSelectedEntitlementId,
  setAddNewFlag,
  setSupportNav,
  setIsSummary,
} from '../../actions/contractAdminActions';
import CASummaryContractInfo from './CASummaryContractInfo';
import CASummaryLocationInfo from './CASummaryLocationInfo';
import CASummaryEntInfo from './CASummaryEntInfo';
import { getSavedEntList } from '../../actions/contractAdminActions';
import {
  fetchPropCodesSuccess,
  getDmaMarkets,
  getPropCodes,
  setSelectedContractId,
} from '../../actions/entitlementActions';

const CASummary = () => {
  const dispatch = useDispatch();
  const [contractList, setContractList] = useState([]);
  const [locationsList, setLocationsList] = useState([]);
  const [selectedContract, setSelectedContract] = useState({});
  const [selectedLocation, setSelectedLocation] = useState({});
  const [savedEntList, setSavedEntList] = useState([]);
  const { addAccount, selectedContractId } = useSelector(state => ({
    addAccount: state.contractAdmin.addAccount,
    selectedContractId: state.contractAdmin.selectedContractId,
  }));
  const getSavedEntListData = (accountId, cont, loc) => {
    dispatch(getSavedEntList(accountId, cont.contractId, loc)).then(
      response => {
        if (response && response.data && response.data.status !== 500) {
          setSavedEntList(response.data.data);
        }
      }
    );
  };

  useEffect(() => {
    // setSavedEntList([]);
    if (selectedContractId) {
      dispatch(getDmaMarkets());
      getPropCodes().then(res =>
        dispatch(fetchPropCodesSuccess(res.data.data.propCodes))
      );
      const defaultSelectedContract = find(addAccount.contracts, {
        contractId: selectedContractId,
      });
      setContractList(addAccount.contracts);
      setLocationsList(addAccount.locations);
      setSelectedContract(defaultSelectedContract);
      setSelectedLocation(addAccount.locations[0]);
      getSavedEntListData(
        addAccount.accountId,
        defaultSelectedContract,
        addAccount.locations[0]
      );
    }
  }, []);

  const selectedContractFn = item => {
    // setSavedEntList(response.data);
    const obj = find(addAccount.contracts, { contractId: item.contractId });
    dispatch(setSelectedContractId(item.contractId));
    getSavedEntListData(addAccount.accountId, obj, selectedLocation);
    setSelectedContract(obj);
  };
  const selectedLocationFn = item => {
    // setSavedEntList([]);
    const obj = find(addAccount.locations, { locationId: item.locationId });
    getSavedEntListData(addAccount.accountId, selectedContract, obj);
    setSelectedLocation(obj);
  };
  const setEntitlementFlag = entitlementId => {
    if (entitlementId) {
      dispatch(setSupportNav('Contract', 'Entitlement Creation'));
      dispatch(setAddNewFlag(false));
      dispatch(setEditEntitlement(true));
      dispatch(setIsSummary(false));
      dispatch(setSelectedEntitlementId(entitlementId));
    }
  };

  return (
    <React.Fragment>
      <div>
        <div
          className="summary-content"
          id="stickytypeheader"
          data-test="Summary"
        >
          <div className="summary-header">
            <div className="summary-header-first-item">
              <span className="summary-header-first-item-heading">
                Account&nbsp;
              </span>
              <span>{addAccount.accountName}</span>
            </div>
            <div className="summary-header-other-item">
              <span className="summary-header-other-item-heading">
                Vertical&nbsp;
              </span>
              {addAccount.industryTypeDesc}
            </div>
            <div className="summary-header-other-item">
              <span className="summary-header-other-item-heading">Access</span>{' '}
              {addAccount.accountType.toLowerCase()}
            </div>
          </div>
        </div>
        <div>
          <div className="sumary-contract-loc-row ca-summary-dropdown">
            <div className="contract-col" title="Contract">
              <CommonDropdown
                data-test="contractDropdown"
                listData={getContractList(contractList)}
                defaultSelected={getDefaultSummaryLocAndCon(
                  'contract',
                  selectedContract,
                  selectedLocation
                )}
                placeHolder="Contract"
                itemClickFn={e => selectedContractFn(e)}
              />
              {!_.isEmpty(selectedContract) && (
                <CASummaryContractInfo selectedContract={selectedContract} />
              )}
            </div>
            <div className="mid-col ca-summary-dropdown mid-block">AND</div>
            <div className="loc-col" title="Location">
              <CommonDropdown
                listData={getLocationsList(locationsList)}
                defaultSelected={getDefaultSummaryLocAndCon(
                  'locations',
                  selectedContract,
                  selectedLocation
                )}
                placeHolder="Location"
                itemClickFn={e => selectedLocationFn(e)}
                data-test="locationDropdown"
              />
              {!_.isEmpty(selectedLocation) && (
                <CASummaryLocationInfo selectedLocation={selectedLocation} />
              )}
            </div>
          </div>
        </div>
        {savedEntList.length > 0 && (
          <div className="summay-ent-ifo-block">
            <CASummaryEntInfo
              savedEntList={savedEntList}
              setEntitlementFlag={setEntitlementFlag}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

CASummary.propTypes = {
  addAccount: PropTypes.instanceOf(Object),
};

export default CASummary;
